export function formatMessage(
  className: unknown,
  methodName: unknown,
  message: unknown
) {
  return `${className} | ${methodName} | ${message}`
}
